export const MAX_REDEMPTIONS_TITLE_THRESHOLD = 20
export const ANALYTICS = 'referAFriendToJoin'
export const AFFILIATE_LEARN_MORE_LINK =
  'https://help.fourthwall.com/hc/en-us/articles/32810496445979-Fourthwall-Affiliate-Program'
